module.exports = {
      id: "prothomalo-trust-usage",
      viewBox: "0 0 260 65",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#prothomalo-trust",
      toString: function () {
        return this.url;
      }
    }